import Vue from 'vue';
import { MutationTree } from 'vuex';

const instanceOfUserSocialNetwork = (
  array: Store.LiveSocial.LiveSocialNetwork[] | Store.LiveSocial.UserSocialNetwork[],
): array is Store.LiveSocial.UserSocialNetwork[] => (
  'lives' in array[0]
);

const liveSocialMutations: MutationTree<Store.LiveSocial.State> = {
  removeService(state, payload: Store.LiveSocial.Actions.DeleteService) {
    const { indexProvider, provider, serviceId } = payload;
    const accountsOrServices = state.providers[provider];

    if (instanceOfUserSocialNetwork(accountsOrServices)) {
      // Store.LiveSocial.UserSocialNetwork[]
      Vue.set(
        state.providers[provider][indexProvider],
        'lives',
        accountsOrServices[indexProvider].lives?.filter((service) => service.id !== serviceId),
      );
    } else {
      // Store.LiveSocial.LiveSocialNetwork[]
      Vue.set(
        state.providers,
        provider,
        accountsOrServices.filter((service) => service.id !== serviceId),
      );
    }
  },
  removeUserAccount(state, payload: Store.LiveSocial.Actions.DeleteUserAccount) {
    const accounts = state.providers[payload.provider] as Store.LiveSocial.UserSocialNetwork[];

    accounts.splice(payload.indexProvider, 1);

    Vue.set(state.providers, payload.provider, accounts);
  },
  setLiveSocialGeneral(state, payload: Services.LiveSocial.Response.LiveSocialGeneralData) {
    Vue.set(state, 'general', {
      description: payload.description,
      id: payload.id,
      madeForKids: payload.madeForKids,
      privacyStatus: payload.privacyStatus,
      title: payload.title,
    } as Store.LiveSocial.General);
  },
  setSelectedServices(state, payload: Store.LiveSocial.Mutations.SetSelectedServices) {
    const { providers, servicesIds, select } = payload;

    providers.forEach((provider, index) => {
      const accountsOrServices = state.providers[provider];
      if (instanceOfUserSocialNetwork(accountsOrServices)) {
        // Store.LiveSocial.UserSocialNetwork[]
        accountsOrServices.forEach((_, accountIndex) => {
          Vue.set(
            state.providers[provider][accountIndex],
            'lives',
            accountsOrServices[accountIndex].lives?.map((service) => (
              service.id === servicesIds[index]
                ? { ...service, selected: select }
                : service
            )),
          );
        });
      } else {
        // Store.LiveSocial.LiveSocialNetwork[]
        Vue.set(
          state.providers,
          provider,
          accountsOrServices.map((service) => (
            service.id === servicesIds[index]
              ? { ...service, selected: select }
              : service
          )),
        );
      }
    });
  },
  setService(state, payload: Store.LiveSocial.LiveSocialNetwork) {
    const newService = { ...payload, selected: false };
    const services = [...state.providers[payload.provider], newService];

    Vue.set(state.providers, payload.provider, services);
  },
  setServices(state, payload: Store.LiveSocial.Mutations.SetServices) {
    Vue.set(state.providers, payload.provider, payload.services);
  },
  setUserAccounts(state, payload: Store.LiveSocial.Mutations.SetUserAccounts) {
    Vue.set(state.providers, payload.provider, payload.accounts);
  },
  updateService(state, payload: Store.LiveSocial.LiveSocialNetwork) {
    const accountsOrServices = state.providers[payload.provider];

    if (instanceOfUserSocialNetwork(accountsOrServices)) {
      // Store.LiveSocial.UserSocialNetwork[]
      accountsOrServices.every((account, accountIndex) => {
        const serviceIsOnAccount = account.lives?.some((service) => service.id === payload.id);

        if (serviceIsOnAccount) {
          Vue.set(
            state.providers[payload.provider][accountIndex],
            'lives',
            account.lives?.map((service) => (
              service.id === payload.id
                ? { ...payload, selected: service.selected }
                : service
            )),
          );

          return false; // Finaliza o loop
        }

        return true; // Continua o loop
      });

      return;
    }

    // Store.LiveSocial.LiveSocialNetwork[]
    Vue.set(
      state.providers,
      payload.provider,
      accountsOrServices.map((service) => (
        service.id === payload.id
          ? { ...payload, selected: service.selected }
          : service
      )),
    );
  },
  updateChatWebsocket(state, payload: any | null) {
    Vue.set(state, 'chatWebsocket', payload);
  },
  updateServiceWebsocket(
    state,
    payload: {
      serviceId: string;
      websocketConnected: boolean;
    },
  ) {
    let ids = {} as { accountIndex: number; serviceIndex: number };

    for (let accountIndex = 0; accountIndex < state.providers.facebook.length; accountIndex += 1) {
      const account = state.providers.facebook[accountIndex];
      const serviceIndex = account.lives?.findIndex((service) => service.id === payload.serviceId);

      if (serviceIndex && serviceIndex !== -1) ids = { accountIndex, serviceIndex };
    }

    if (!Object.keys(ids).length) return;

    const { accountIndex, serviceIndex } = ids;

    const lives = state.providers.facebook[accountIndex].lives?.map((service, index) => ({
      ...service,
      websocketConnected: index === serviceIndex
        ? payload.websocketConnected
        : service.websocketConnected,
    }));

    Vue.set(state.providers.facebook[accountIndex], 'lives', lives);
  },
  setYoutubeLivestreamUserSettings(state, payload: Store.LiveSocial.YoutubeLivestreamUserSettings) {
    Vue.set(state, 'youtubeLivestreamUserSettings', payload);
  },
};

export default liveSocialMutations;
